import classnames from 'classnames';
import React from 'react';

export interface Key {
  label: Exclude<React.ReactNode, null | undefined>;
  color: string;
}

interface LegendProps {
  keys: Key[];
  className?: string;
}

export const Legend = ({ keys = [], className }: LegendProps) => (
  <div className={classnames('mx-auto flex justify-center gap-2', className)}>
    {keys.map(({ label, color }, idx) => (
      <div
        className="flex items-center gap-1 border border-solid border-primary p-2 text-xs text-primary"
        key={label?.toString()}
      >
        <span
          style={{
            backgroundColor: color,
          }}
          // Alternate between square and circle icons
          className={classnames(
            idx % 2 ? '' : 'rounded-[50%]',
            'size-2.5 min-w-[10px]',
          )}
        />
        {label}
      </div>
    ))}
  </div>
);
